import { Form, Input } from "antd";
import { useIntl } from "react-intl";

import { FormFieldContainer } from "./styled";

export const SwitchField = () => {
  const intl = useIntl();

  return (
    <FormFieldContainer>
      <Form.Item
        name="label"
        label={intl.formatMessage({ id: "newFormField.fieldLabel" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.fieldLabelRequired",
            }),
          },
        ]}
      >
        <Input />
      </Form.Item>
    </FormFieldContainer>
  );
};
